/* REACT */
import React, { useState, useEffect } from 'react'

/* 3RD PARTIES */
import { connect } from 'react-redux'

/* COMPONENTS */
import { Image } from '../../../../components/ui'

/* STORE */

/* STYLES */
import {
  MessageAvatarContainer,
  MessageContainer,
  MessageContentContainer,
  TypingContainer,
  TypingDot,
  ReasoningText,
} from './style'

/* UTILS/CONSTANTS*/
import { CLIENT_STYLINGS } from '../../../../utils/constants'
import { getTranslations } from '../../../../utils'
/* ASSETS */

const Typing = ({ isGridMode = false, organizationSlug }) => {
  const MayaAvatar = CLIENT_STYLINGS[organizationSlug].MAYA_AVATAR_URL
  const mayaTypingMessages = getTranslations('maya_typing_messages')
  const [currentMessage, setCurrentMessage] = useState(
    mayaTypingMessages[0] || ''
  )

  const changeMessage = index => {
    setCurrentMessage(mayaTypingMessages[index])
  }

  useEffect(() => {
    let index = 0
    let timer = null
    timer = setInterval(() => {
      if (index < mayaTypingMessages.length - 1) {
        index = index + 1
        changeMessage(index) // IN ORDER TO AVOID REPEATING MESSAGES
      }
    }, 3000)

    return () => {
      clearInterval(timer)
    }
  }, [])

  return (
    <MessageContainer>
      <MessageContentContainer>
        {!isGridMode && (
          <MessageAvatarContainer sender={true}>
            <Image
              src={MayaAvatar}
              alt='Message Avatar'
              width={'40px'}
              height={'40px'}
              objectFit={'contain'}
            />
          </MessageAvatarContainer>
        )}
        <TypingContainer>
          <ReasoningText>{currentMessage}</ReasoningText>
        </TypingContainer>
      </MessageContentContainer>
    </MessageContainer>
  )
}

const mapStateToProps = state => ({
  organizationSlug: state.general.organizationSlug,
})

const mapDispatchToProps = dispatch => ({})

export default connect(mapStateToProps, mapDispatchToProps)(Typing)
